import axios from 'axios'

export const INFORMACOES_CARGA_RECUPERADA = '@informacoesCargaActions/INFORMACOES_CARGA_RECUPERADA'
export const informacoesCargaUrl = '/bff/informacoes-carga'
export const axiosWrapper = axios

export const recuperarInformacoesCarga = () => {
  return (dispatch) => {
    axios.get(informacoesCargaUrl).then((response) => {
      const informacoesCarga = response.data
      return dispatch({
        type: INFORMACOES_CARGA_RECUPERADA,
        payload: informacoesCarga
      })
    })
  }
}
